import APIUtils from '@spothero/utils/api';
import ErrorUtils from 'utils/error-utils';

// Default rating and count are hard coded to match with current App Store rating and is used only when api call fails.
// Note: This value should be kept in sync with App Store rating.
export const DEFAULT_RATING = 4.8;
export const DEFAULT_USER_RATING_COUNT = 122766;

const AppRatingAPI = {
    get() {
        return APIUtils.get(
            `https://itunes.apple.com/lookup?bundleId=com.spothero.spothero&country=us`
        )
            .then(res => {
                const {
                    averageUserRating,
                    userRatingCount,
                } = res.data.results[0];

                return {
                    data: {
                        rating: Number(averageUserRating.toFixed(1)),
                        ratingCount: userRatingCount,
                    },
                };
            })
            .catch(error => {
                ErrorUtils.sendSentryError(error);

                return {
                    data: {
                        rating: DEFAULT_RATING,
                        ratingCount: DEFAULT_USER_RATING_COUNT,
                    },
                };
            });
    },
};

export default AppRatingAPI;
